<template>
  <div class="scrollable-container">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'HorizontallyScrollableContainer'
}
</script>

<style scoped>
  .scrollable-container {
    margin: 1rem 0 1rem 0;
    -ms-overflow-style: none;
    -ms-overflow-x: scroll;
    overflow: -moz-scrollbars-none;
    overflow-x: scroll;
  }
  .scrollable-container::-webkit-scrollbar {
    display: none !important;
  }
</style>
